import { activities } from "../content";
import { SectionHeading } from "./SectionHeading";

export function Activities() {
  return (
    <section
      className="content-section"
      id="activities"
      aria-labelledby="activities-title"
    >
      <div className="content-width section-layout">
        <SectionHeading
          index="ACTIVITIES"
          title="活動内容"
          id="activities-title"
        />
        <div className="section-body">
          <p className="section-lead">
            競う、学ぶ、つながる。
            <br />
            その先の挑戦をつくる。
          </p>
          <div className="activity-list">
            {activities.map((activity) => (
              <article className="activity-item" key={activity.number}>
                <span className="activity-number">{activity.number}</span>
                <div>
                  <h3>{activity.title}</h3>
                  <p>{activity.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
